import { Link } from "react-router-dom";

interface Props {
  kicker: string;
  title: string;
  desc?: string;
  link?: string;
  linkLabel?: string;
  center?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  link,
  linkLabel = "查看全部",
  center,
}: Props) {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 sm:mb-8 sm:flex-row sm:items-end sm:justify-between ${
        center ? "sm:flex-col sm:items-center sm:text-center" : ""
      }`}
    >
      <div className={center ? "text-center" : ""}>
        <span
          className={`label-caps text-accent-700 ${
            center ? "justify-center" : ""
          }`}
        >
          <i className="ri-asterisk"></i>
          {kicker}
        </span>
        <h2 className="mt-2 flex items-center gap-3 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
          {!center && (
            <span className="h-7 w-1.5 rounded-full bg-primary-500"></span>
          )}
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {link && (
        <Link
          to={link}
          className="group inline-flex shrink-0 items-center gap-1.5 self-start whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700 sm:self-auto"
        >
          {linkLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </Link>
      )}
    </div>
  );
}